/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { UserSession } from "usersession";

function ApplyNowPost(props) {
  var userSession = new UserSession();

  var setAppReqData = props.ssLeadData;
  var borrowerData = props.ssLeadData.borrower;
  var amortizationType = "";

  var extLoanAmount = "";
  var extDownPayment = "";
  var extAppraisalAmount = "";
  var extLoanType = "";
  var extLoanPurpose = "";
  var extPropertyZip = "";
  var extPropertyState = "";
  var extFirstName = "";
  var extLastName = "";
  var extPhone = "";
  var extEmail = "";
  var extLeadSource = "";
  var extRate = "";
  var extBranch = "";
  var extLoanTerm = "";
  var extPropertyOccupancy = "";

  var extCashOut = "";
  var extCreditScore = "";
  var extPropertyType = "";
  var extPropertyCounty = "";
  var extDiscountCode = "";
  var extDiscountAmount = "";
  var extDiscountPoints = "";
  var extLenderCredit = "";
  var lof = "";
  var extProductCode = "";
  var extPaymentType = "";
  var extPromoCode = "";
  var extVABranchOfService = "";

  if (!props.ssLeadData.applicationNumber) {
    if (props.ssLeadData.loanTerm == "15" && props.ssLeadData.loanType == "Conventional") {
      amortizationType = "A0-01-0E-000";
    } else if (props.ssLeadData.loanTerm == "15" && props.ssLeadData.loanType !== "Conventional") {
      amortizationType = "A0-01-04-000";
    } else {
      amortizationType = "A0-01-05-000";
    }

    switch (setAppReqData.offerLoanType) {
      case "200":
        extLoanType = "FNMA";
        break;
      case "111":
        extLoanType = "FHA";
        break;
      case "120":
        extLoanType = "VA";
        break;
      case "130":
        extLoanType = "USDA";
        break;
      //no default
    }

    // When for some reason the lead is not created, then we need to sendn the request with all the lead fields to Apply Now.
    // The below parameters are added to the inputs value of the form, and then they are sent in the form post to Apply now.
    extLoanAmount = userSession.getPurchasePrice() > 0 ? userSession.getPurchasePrice() : userSession.getCurrentLoanBalance();
    extDownPayment = userSession.getDownPaymentAmount();
    extAppraisalAmount = userSession.getEstimatedValue();
    extLoanPurpose = userSession.getLoanPurposeCode();
    extPropertyZip = userSession.getPropertyZipCode();
    extPropertyState = setAppReqData.propertyAddressState;
    extFirstName = borrowerData.firstName;
    extLastName = borrowerData.lastName;
    extPhone = borrowerData.phone;
    extEmail = borrowerData.email;
    extLeadSource = setAppReqData.leadSource;
    extRate = setAppReqData.offerRate;
    extBranch = setAppReqData.branch;
    extLoanTerm = setAppReqData.offerTerm;
    extPropertyOccupancy = userSession.getPropertyUseCode();
    extCashOut = userSession.getCashOutAmount();
    extCreditScore = userSession.getCreditScore();
    extPropertyType = userSession.getPropertyType();
    extPropertyCounty = userSession.getPropertyCounty();
    extDiscountCode = "";
    extDiscountAmount = "";
    extDiscountPoints = "";
    extLenderCredit = "";
    lof = "LMT0";
    extProductCode = setAppReqData.offerLoanProductCode;
    extPaymentType = amortizationType;
    extPromoCode = setAppReqData.promoCode;
    extVABranchOfService = "";
  }

  useEffect(function () {
    userSession.loadCustomQuoteData();
  }, []);

  var applyNowRef = useRef(null);

  useEffect(function () {
    applyNowRef.current.click();
    props.closeModal();
  }, []);

  return React.createElement(
    React.Fragment,
    null,
    props.ssLeadData.applicationNumber ? React.createElement(
      Form,
      {
        method: "post",
        target: "_blank",
        action: process.env.REACT_APP_APPLY_NOW + "&leadNumber=" + props.ssLeadData.applicationNumber
      },
      React.createElement(
        Row,
        { hidden: true },
        React.createElement(
          Col,
          null,
          React.createElement(
            Button,
            { type: "submit", ref: applyNowRef },
            "Apply"
          )
        )
      )
    ) : React.createElement(
      Form,
      {
        method: "post",
        target: "_blank",
        action: "" + process.env.REACT_APP_APPLY_NOW_NOLEAD
      },
      React.createElement(
        Row,
        { hidden: true },
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLoanType",
            readOnly: true,
            value: extLoanType,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLoanPurpose",
            readOnly: true,
            value: extLoanPurpose,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLoanTerm",
            readOnly: true,
            value: extLoanTerm,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPropertyZip",
            readOnly: true,
            value: extPropertyZip,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPropertyState",
            readOnly: true,
            value: extPropertyState,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extFirstName",
            readOnly: true,
            value: extFirstName,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLastName",
            readOnly: true,
            value: extLastName,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPhone",
            readOnly: true,
            value: extPhone,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extEmail",
            readOnly: true,
            value: extEmail,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLeadSource",
            readOnly: true,
            value: extLeadSource,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extProductCode",
            readOnly: true,
            value: extProductCode,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extRate",
            readOnly: true,
            value: extRate,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extBranch",
            readOnly: true,
            value: extBranch,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLoanAmount",
            readOnly: true,
            value: extLoanAmount,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extDownPayment",
            readOnly: true,
            value: extDownPayment,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extCashOut",
            readOnly: true,
            value: extCashOut,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extAppraisalAmount",
            readOnly: true,
            value: extAppraisalAmount,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extCreditScore",
            readOnly: true,
            value: extCreditScore,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPropertyType",
            readOnly: true,
            value: extPropertyType,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPropertyOccupancy",
            readOnly: true,
            value: extPropertyOccupancy,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPropertyCounty",
            readOnly: true,
            value: extPropertyCounty,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extDiscountCode",
            readOnly: true,
            value: extDiscountCode,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extDiscountAmount",
            readOnly: true,
            value: extDiscountAmount,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extDiscountPoints",
            readOnly: true,
            value: extDiscountPoints,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extLenderCredit",
            readOnly: true,
            value: extLenderCredit,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "lof",
            value: lof,
            readOnly: true,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extVABranchOfService",
            readOnly: true,
            value: extVABranchOfService,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPaymentType",
            readOnly: true,
            value: extPaymentType,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Form.Group,
          { as: Col },
          React.createElement(Form.Control, {
            type: "text",
            name: "extPromoCode",
            readOnly: true,
            value: extPromoCode,
            autoComplete: "off"
          })
        ),
        React.createElement(
          Col,
          null,
          React.createElement(
            Button,
            { type: "submit", ref: applyNowRef },
            "Apply"
          )
        )
      )
    )
  );
}

export default ApplyNowPost;